import {z} from 'zod';

const PhoneNumberSchemaMetadaWorkshopHandover = z.object({
  countryCode: z.string(),
  number: z.string(),
  prefix: z.string(),
});

const DriverSchemaMetadaWorkshopHandover = z.object({
  id: z.string().nullable().optional(),
  name: z.string().nullable().optional(),
  phoneNumber: PhoneNumberSchemaMetadaWorkshopHandover.nullable().optional(),
  email: z.string().nullable().optional(),
  identityCard: z.string().nullable().optional(),
});

const ServiceHandOverCommonSchema = z.object({
  serviceCheckinId: z.string().nullable().optional(),
  state: z.enum(['SCHEDULED', 'COMPLETED']).nullable().optional(),
  scheduledDate: z.string().nullable().optional(),
  completedDate: z.string().nullable().optional(),
  driver: DriverSchemaMetadaWorkshopHandover.nullable().optional(),
  mileage: z.number().nullable().optional(),
  fuelTank: z.number().nullable().optional(),
  technicalInspection: z.string().nullable().optional(),
  emissions: z.string().nullable().optional(),
  note: z.string().nullable().optional(),
  isVehicleNotInService: z.boolean().nullable().optional(),
  isNonDrivableVehicle: z.boolean().nullable().optional(),
  inspectionId: z.array(z.string()).nullable().optional(),
});

export const GetServiceHandOverApiResponseSchema = ServiceHandOverCommonSchema.nullable();

export type GetServiceHandOverApiResponse = z.infer<typeof GetServiceHandOverApiResponseSchema>;

export const GetServiceHandOverApiArgSchema = z.object({
  serviceCaseId: z.string(),
});

export type GetServiceHandOverApiArg = z.infer<typeof GetServiceHandOverApiArgSchema>;

const CheckinCreateEditResponse = z
  .object({
    isMileageValid: z.boolean(),
    highestMileage: z.number().nullable().optional(),
  })
  .nullable();

export const PostServiceHandOverApiResponseSchema = CheckinCreateEditResponse;
export type PostServiceHandOverApiResponse = z.infer<typeof PostServiceHandOverApiResponseSchema>;

const PostServiceHandOverBodySchema = ServiceHandOverCommonSchema.extend({
  withFuelTankMileageUpdate: z.boolean().nullable().optional(),
}).omit({
  serviceCheckinId: true,
});

export const PostServiceHandOverApiArgSchema = z.object({
  serviceCaseId: z.string(),
  body: PostServiceHandOverBodySchema.nullable(),
});

export type PostServiceHandOverApiArg = z.infer<typeof PostServiceHandOverApiArgSchema>;

export const PatchServiceHandOverApiResponseSchema = CheckinCreateEditResponse;
export type PatchServiceHandOverApiResponse = z.infer<typeof PatchServiceHandOverApiResponseSchema>;

const PatchServiceHandOverBodySchema = PostServiceHandOverBodySchema;

export const PatchServiceHandOverApiArgSchema = z.object({
  serviceCaseId: z.string(),
  body: PatchServiceHandOverBodySchema.nullable(),
});

export type PatchServiceHandOverApiArg = z.infer<typeof PatchServiceHandOverApiArgSchema>;

export const GetServiceHandOverDefaultDriverApiApiResponseSchema = z.object({
  driverEmail: z.string().nullable().optional(),
  driverFirstname: z.string().nullable().optional(),
  driverIdentityCard: z.string().nullable().optional(),
  driverLastname: z.string().nullable().optional(),
  driverPhoneNo: z.string().nullable().optional(),
  driverPhonePrefix: z.string().nullable().optional(),
  driverPhoneCountryCode: z.string().nullable().optional(),
});

export type GetServiceHandOverDefaultDriverApiApiResponse = z.infer<
  typeof GetServiceHandOverDefaultDriverApiApiResponseSchema
>;

export const GetServiceHandOverDefaultDriverApiApiArgSchema = z.object({
  serviceCaseId: z.string(),
});

export type GetServiceHandOverDefaultDriverApiApiArg = z.infer<
  typeof GetServiceHandOverDefaultDriverApiApiArgSchema
>;

// Export new schemas
export {DriverSchemaMetadaWorkshopHandover};
export type DriverTypeMetadaWorkshopHandover = z.infer<typeof DriverSchemaMetadaWorkshopHandover>;
export {PhoneNumberSchemaMetadaWorkshopHandover};
export type PhoneNumberTypeMetadaWorkshopHandover = z.infer<
  typeof PhoneNumberSchemaMetadaWorkshopHandover
>;
